import { mapEnumToOptions } from '@abp/ng.core';

export enum DataSource {
  Native = 0,
  Wms = 1,
}

export const dataSourceOptions = mapEnumToOptions(DataSource);
